import { web_path } from '@common/constants';

import { RouteType } from './types';

/**
 * title값은 public/locales 내의 routeTitle.json에 우선 추가해야함
 */
export const routes: RouteType[] = [
  { pattern: '/user-locale', page: 'user-locale' },
  { pattern: '/not-support', page: 'not-support' },
  { pattern: '/login', page: 'auth/login' },
  { pattern: '/cart', page: 'cart', category: 'cart', title: '장바구니' },
  { pattern: '/event', page: 'event', title: '회원님을 위한 혜택', category: 'order-sheet' },
  { pattern: '/events/showcase-vol5-0224', page: 'events/showcase-vol5-0224' },
  { pattern: '/events/:uuid', page: 'events' },
  { pattern: '/events/:uuid/reply/:reply_uuid', page: 'events/reply' },
  { pattern: '/benefit', page: 'benefit' },
  { pattern: '/coupon/box/:shop_id', page: 'coupon/downloads', title: '쿠폰받기', category: 'coupon' },
  { pattern: '/coupon/user-box', page: 'coupon/box', title: '쿠폰' },
  { pattern: '/coupon/user-box/search', page: 'coupon/box/search' },
  { pattern: '/coupon/user-box/expired', page: 'coupon/box/expired' },
  { pattern: '/coupon/issue', page: 'coupon/issue', title: '쿠폰등록' },
  { pattern: '/coupon/issue-redirect', page: 'coupon/issue-redirect' },
  { pattern: '/coupon/detail/:user_account_coupon_policy_id', page: 'coupon/detail', title: '쿠폰' },
  { pattern: '/conv-payment-method', page: 'conv-payment-method', title: '입금방법' },
  { pattern: '/my-pick/main', page: 'my-pick/main', title: '마이픽쿠폰' },
  { pattern: '/my-pick/my-coupon', page: 'my-pick/my-coupon' },
  { pattern: '/my-pick/select', page: 'my-pick/select' },
  { pattern: '/my-pick/search', page: 'my-pick/search' },
  { pattern: '/my-pick/tutorial', page: 'my-pick/tutorial' },
  { pattern: '/my-pick/user-requested', page: 'my-pick/user-requested' },
  { pattern: '/my-pick/5-tab-banner', page: 'my-pick/5-tab-banner', title: '마이픽쿠폰 배너 이미지' },
  { pattern: '/address-book', page: 'address-book/main', title: '배송지 목록' },
  { pattern: '/address-book/edit/new', page: 'address-book/edit', title: '배송지 추가' },
  { pattern: '/address-book/edit/:address_id', page: 'address-book/edit', title: '배송지 수정' },
  { pattern: '/postcode', page: 'postcode', title: '우편번호 검색' },
  {
    pattern: '/postcode/business-juso-response',
    page: 'postcode/business-juso-response',
  },
  {
    pattern: '/order-sheets/:uuid',
    page: 'order-sheet',
    title: '주문/결제',
    type: 'checkout',
    category: 'order-sheet',
  },
  {
    pattern: '/order-completed/:order_number',
    page: 'order-completed',
    title: '결제',
    type: 'order_completed',
    category: 'order',
  },
  { pattern: '/checkout-failed', page: 'checkout-failed', title: '결제', type: 'checkout', category: 'order' },
  { pattern: '/order-item-inquiries', page: 'order-item-inquiries/main', title: '문의 내역', category: 'order' }, // need loggedin
  { pattern: '/order-item-inquiries/qna', page: 'order-item-inquiries/qna', title: '문의 내역', category: 'order' }, // need loggedin
  { pattern: '/order-item-inquiries/new', page: 'order-item-inquiries/new', title: '문의하기', category: 'order' }, // need loggedin
  {
    pattern: '/order-item-inquiries/qna/new',
    page: 'order-item-inquiries/qna-new',
    title: '문의하기',
    category: 'order',
  }, // need loggedin
  { pattern: '/orders/:order_number', page: 'orders/show', title: '주문 상세', category: 'order' }, // need loggedin
  {
    pattern: '/order-item-requests/:order_item_request_number/cancel-info',
    page: 'order-item-requests/cancel-info',
    title: '취소 정보',
    category: 'order-request',
  }, // need loggedin
  {
    pattern: '/order-item-requests/:order_item_request_number/return-info',
    page: 'order-item-requests/return-info',
    title: '반품 정보',
    category: 'order-request',
  }, // need loggedin
  {
    pattern: '/order-item-requests/:order_item_request_number/exchange-info',
    page: 'order-item-requests/exchange-info',
    title: '교환 정보',
    category: 'order-request',
  }, // need loggedin
  {
    pattern: '/order-items/:order_item_number/shipping-schedule-delay-info',
    page: 'order-items/shipping-schedule-delay-info',
    title: '배송연기 안내',
    category: 'order',
  }, // need loggedin
  {
    pattern: '/order-items/:order_item_number/shipping-defer',
    page: 'order-items/shipping-defer',
    title: '배송보류 안내',
    category: 'order',
  }, // need loggedin
  { pattern: '/orders/:order_number/confirm', page: 'orders/confirm', title: '구매확정', category: 'order' }, // need loggedin
  { pattern: '/orders/:order_number/confirm-completed', page: 'orders/confirm-completed', category: 'order' },
  { pattern: '/orders/:order_number/cancel', page: 'orders/cancel', title: '미입금 주문 취소', category: 'order' }, // need loggedin
  {
    pattern: '/orders/:order_number/cancel-completed',
    page: 'orders/cancel-completed',
    title: '미입금 주문 취소',
    category: 'order',
  }, // need loggedin
  {
    pattern: '/orders/:order_number/request-cancel',
    page: 'orders/request/cancel',
    title: '주문 취소',
    category: 'order-request',
  }, // need loggedin
  {
    pattern: '/orders/:order_number/request-return',
    page: 'orders/request/return',
    title: '주문 반품',
    category: 'order-request',
  }, // need loggedin
  {
    pattern: '/orders/:order_number/request-exchange',
    page: 'orders/request/exchange',
    title: '주문 교환',
    category: 'order-request',
  }, // need loggedin
  {
    pattern: '/orders/:order_number/request-cancel-completed',
    page: 'orders/request-completed/cancel',
    title: '주문 취소',
    category: 'order-request',
  },
  {
    pattern: '/orders/:order_number/request-return-completed',
    page: 'orders/request-completed/return',
    title: '주문 반품',
    category: 'order-request',
  },
  {
    pattern: '/orders/:order_number/request-exchange-completed',
    page: 'orders/request-completed/exchange',
    title: '주문 교환',
    category: 'order-request',
  },
  { pattern: '/pay/simple_bank', page: 'pay/simple_bank', title: '계좌 간편결제', type: 'pay', category: 'order' },
  { pattern: '/pay-completed', page: 'pay-completed', category: 'order' },
  { pattern: '/pay-failed', page: 'pay-failed', category: 'order' },
  { pattern: '/simple-pay/register', page: 'simple-pay/register', title: '간편결제 등록', category: 'simple-pay' },
  { pattern: '/simple-pay/terms', page: 'simple-pay/terms', title: '간편결제 등록', category: 'simple-pay' },
  { pattern: '/simple-pay/banks', page: 'simple-pay/banks', title: '간편결제 등록', category: 'simple-pay' },
  {
    pattern: '/simple-pay/certification',
    page: 'simple-pay/certification',
    title: '간편결제 등록',
    category: 'simple-pay',
  },
  { pattern: '/simple-pay/ars', page: 'simple-pay/ars', title: '간편결제 등록', category: 'simple-pay' },
  { pattern: '/simple-pay/ars-failed', page: 'simple-pay/ars-failed', title: '간편결제 등록', category: 'simple-pay' },
  {
    pattern: '/simple-pay/change-password',
    page: 'simple-pay/change-password',
    title: '결제 비밀번호 변경',
    category: 'simple-pay',
  },
  {
    pattern: '/simple-pay/verify-password',
    page: 'simple-pay/verify-password',
    title: '계좌 간편결제',
    category: 'simple-pay',
  },
  { pattern: '/simple-pay/management', page: 'simple-pay/management', title: '간편결제 관리', category: 'simple-pay' },
  { pattern: '/points', page: 'points/main', title: '포인트', category: 'point' }, // need loggedin
  { pattern: '/points/main/expired', page: 'points/main/expired', title: '포인트', category: 'point' },
  { pattern: '/products/:id/select-option', page: 'products/select-option', category: 'product' },
  { pattern: '/shortform/:catalog_product_id', page: 'short-form' },
  { pattern: '/catalog/products/:catalog_product_id', page: 'products/details' },
  { pattern: '/catalog/__preview/:catalog_product_id', page: 'products/details' },
  { pattern: '/catalog/product/shipping-info', page: 'products/shipping-info' },
  { pattern: '/products/global-size', page: 'products/international-size' },
  { pattern: '/user-refund-account', page: 'user-refund-account', title: '환불계좌', category: 'refund' },
  {
    pattern: '/order-item/:order_item_number/shipping-tracking',
    page: 'shipping-tracking/show-shipping',
    title: '배송 현황',
    category: 'order',
  },
  {
    pattern: '/order-item/:order_item_number/return-shipping-tracking',
    page: 'shipping-tracking/show-return',
    title: '수거 현황',
    category: 'order',
  },
  { pattern: '/membership', page: 'membership', title: '' },
  { pattern: '/low-version', page: 'misc/low-version', title: '' },
  { pattern: '/notice', page: 'notice', title: '공지사항' },
  { pattern: '/notice/:id', page: 'notice/details', title: '' },
  { pattern: web_path.root, page: 'home' },
  { pattern: web_path.home, page: 'home' },
  { pattern: web_path.search, page: 'search' },
  { pattern: web_path.orders, page: 'orders/main' },
  { pattern: web_path.auth.find_email, page: 'auth/find-email' },
  { pattern: web_path.auth.find_email_result, page: 'auth/find-email-result' },
  { pattern: web_path.auth.login, page: 'auth/login' },
  { pattern: web_path.auth.email_login, page: 'auth/email-login' },
  { pattern: web_path.auth.adview_login, page: 'auth/adview-login' },
  { pattern: web_path.auth.find_password, page: 'auth/find-password' },
  { pattern: web_path.auth.sign_up_email, page: 'auth/sign-up-email' },
  { pattern: web_path.auth.write_email, page: 'auth/write-email' },
  { pattern: web_path.auth.terms_agreement, page: 'auth/terms-agreement' },
  { pattern: web_path.auth.mobile_authentication, page: 'auth/mobile-authentication' },
  { pattern: web_path.auth.profile, page: 'auth/profile' },
  { pattern: web_path.auth.edit_profile, page: 'auth/edit-profile' },
  { pattern: web_path.auth.connect_account, page: 'auth/connect-account' },
  { pattern: web_path.auth.duplicate_social_account, page: 'auth/duplicate-social-account' },
  { pattern: web_path.auth.redirect_scope, page: 'auth/redirect-scope' },
  { pattern: web_path.auth.add_kakao_channel, page: 'auth/add-kakao-channel' },
  { pattern: web_path.my_page.root, page: 'my-page/main' },
  { pattern: web_path.categories.root, page: 'categories/navigation' },
  { pattern: web_path.categories.landing, page: 'categories/landing' },
  { pattern: web_path.picks, page: 'picks' },
  { pattern: '/beauty', page: 'beauty', title: '뷰티' },
  { pattern: '/beauty/frequency', page: 'beauty/frequency', title: '뷰티 프리퀀시' },
  { pattern: '/beauty/new-arrivals/:id', page: 'beauty/new-arrivals', title: '뷰티 신상' },
  { pattern: '/authentication', page: 'authentication', title: '본인인증' },
  { pattern: '/authentication/verify', page: 'authentication/verify', title: '본인인증' },
  { pattern: '/authentication/failed', page: 'authentication/failed', title: '본인인증' },
  { pattern: '/auth/apple-callback-app-connect', page: 'auth/apple-callback-app-connect' },
  { pattern: '/auth/apple-callback', page: 'auth/apple-callback' },
  { pattern: '/my_notifications', page: 'notification', title: '알림' },
  { pattern: '/notification/settings', page: 'notification/settings', title: '알림 설정' },
  { pattern: '/notification/settings/category/:category', page: 'notification/settings/category' },
  { pattern: '/:main_domain', page: 'shop/main' },
  { pattern: '/store-home/:shop_id', page: 'shop/id' },
  { pattern: '/:main_domain/search', page: 'shop/search' },
  { pattern: '/:main_domain/category/:category_id', page: 'shop/category-detail' },
  { pattern: '/:main_domain/collection/:collection_id', page: 'shop/collection-detail' },
  { pattern: '/:main_domain/zigzin-shipping', page: 'shop/zigzin-shipping' },
  { pattern: '/:main_domain/shortform/:video_id', page: 'shop/shortform' },
  { pattern: '/review/:order_item_number/write', page: 'review/write', title: '리뷰작성' },
  { pattern: '/review/completed', page: 'review/completed', title: '리뷰작성완료' },
  {
    pattern: '/kakaopay-banners/mypage',
    page: 'kakaopay-banners/mypage',
    title: '',
  },
  { pattern: '/profile/body', page: 'profile/body', title: '체형정보' },
  { pattern: '/review-report/:product_review_id', page: 'review-report' },
  { pattern: '/advertisement/exhibition/:uuid', page: 'advertisement/exhibition' },
  { pattern: '/advertisement/bridge/:ad_id/:creative_id', page: 'advertisement/bridge' },
  { pattern: '/advertisement/daily-mission', page: 'advertisement/daily-mission', title: '오늘의 혜택' },
  { pattern: '/advertisement/mission-detail', page: 'advertisement/mission-detail' },
  { pattern: '/advertisement/mission-randombox', page: 'advertisement/mission-randombox', title: '랜덤박스' },
  { pattern: '/advertisement/mission-roulette/:id', page: 'advertisement/mission-roulette', title: '출석체크' },
  { pattern: '/advertisement/mission-certification', page: 'advertisement/mission-certification', title: '' },
  {
    pattern: '/advertisement/mission-provision/:type',
    page: 'advertisement/mission-provision',
    title: '사용자 약관',
  },
  { pattern: '/advertisement/qrcode', page: 'advertisement/qrcode', title: '' },
];
